





























	import AbpBase from "../../../lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import {
    InsertAssayCategoryGroup,
    UpdateAssayCategoryGroup,
    DeleteAssayCategoryGroup,
    GetAssayCategoryGroupList,
} from '../../../api/basicDictionary'

@Component
export default class extends AbpBase {
    @Prop() value: boolean;
    data: any = [];
    loading = false;
    dialogForm: any = {};
    dialogShow = false;
    columns: any = [
        {
            title: "分组名称",
            key: "groupName",
        },
        {
            title: "操作",
            width: 160,
            render: (h: any, p: any) => {
                return h("div", [
                    h(
                        "Button",
                        {
                            props: {
                                type: "primary",
                                size: "small",
                            },
                            style: {
                                marginRight: "15px",
                            },
                            on: {
                                click: () => {
                                    this.update(p.row);
                                },
                            },
                        },
                        "修改"
                    ),
                    h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            on: {
                                click: () => {
                                    this.remove(p.row);
                                },
                            },
                        },
                        "删除"
                    ),
                ]);
            },
        },
    ];

    created() {
        this.getData();
    }

    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
    }

    cancel() {
        this.$emit("input", false);
    }

    add() {
        this.dialogForm = {};
        this.dialogShow = true;
    }

    update(row: any) {
        this.dialogForm = Object.assign({}, row);
        this.dialogShow = true;
    }

    remove(row: any) {
        this.$Modal.confirm({
            title: "提示",
            content: "确定要删除吗？",
            onOk: async () => {
                await DeleteAssayCategoryGroup({ id: row.id });
                this.getData();
            },
        });
    }

    async getData() {
        this.loading = true;
        let res = await GetAssayCategoryGroupList();
        this.data = res.objects;
        this.loading = false;
    }

    async save() {
        let res;
        if (this.dialogForm.id) {
            res = await UpdateAssayCategoryGroup(this.dialogForm);
        } else {
            res = await InsertAssayCategoryGroup(this.dialogForm);
        }
        if (res.status == 1) {
            this.dialogShow = false;
            this.getData();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/assayCategory/assayCategoryGroup.vue